import { render, staticRenderFns } from "./FilterOrador.vue?vue&type=template&id=8ebc2f76"
import script from "./FilterOrador.vue?vue&type=script&lang=js"
export * from "./FilterOrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports